import { useLingui } from '@lingui/react';
import { Button } from '@mantine/core';
import classes from './Stats.module.css';
export const PlayNowButton: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Button radius={5} fullWidth fz={10} className={classes.button}>
      {i18n._('PLAY NOW')}
    </Button>;
};